"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelCompositorCategory_1 = __importDefault(require("./ModelCompositorCategory"));
class ModelCompositorCategorys {
    constructor(rates) {
        this.customOrderCategories = ['A++', 'A+', 'A', 'B', 'C', 'D'];
        this.rates = rates || new Array();
    }
    getAllCategorys() {
        return this.rates;
    }
    getOrderCategories() {
        if (this.customOrderCategories) {
            let categories = this.rates;
            categories = this.rates.sort((a, b) => {
                const indexA = this.customOrderCategories.indexOf(a.category);
                const indexB = this.customOrderCategories.indexOf(b.category);
                if (indexA === -1)
                    return 1;
                if (indexB === -1)
                    return -1;
                return indexA - indexB;
            });
            return categories;
        }
    }
    getCategoryHighestCounter() {
        return (this.rates
            .filter((category) => category.count > 0)
            .sort((a, b) => b.count - a.count)
            .shift() || this.rates[0]);
    }
    filterByCategory(category) {
        for (const categoryItem of this.rates) {
            if (categoryItem.category === category) {
                console.log('Model current category:', categoryItem);
                return new ModelCompositorCategory_1.default(categoryItem, false);
            }
        }
    }
}
exports.default = ModelCompositorCategorys;
